module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/shape-4-c900ec8caaac3cbbc078537ef6ac64e0.png";